(function () {

    WorkVisasService.$inject = ['TSUsersService', 'workRestrictionsService'];
    function WorkVisasService(TSUsersService, workRestrictionsService) {
        var self = this;

        self.workVisasRules = [];
        self.usersWorkVisaTypes = {};
        self.workVisasWarningsPerShift = {};
        self.workVisasUsersWarning = {};
        var workVisasUsersWorkMap = {};

        self.parseUsersWorkVisaTypes = function (startOfWeek, usersSchoolTemplates, brandWorkVisasTypes) {
            var startOfCalenderWeek = moment(startOfWeek, 'MMM DD, YYYY');
            var endOfWeekDate = startOfCalenderWeek.clone().add(6, 'days').format('MMM DD, YYYY');

            for (var i = 0; i < usersSchoolTemplates.length; i++) {
                var user = usersSchoolTemplates[i];

                for (var j = 0; j < user.school_templates.length; j++) {
                    var template = user.school_templates[j];
                    var visaTypeStartDate = moment(template.start_date, "YYYY-MM-DDTHH:mm:ss");
                    var visaTypeEndDate = template.end_date ? moment(template.end_date, "YYYY-MM-DDTHH:mm:ss").endOf('day') : null;

                    if (template.work_visa_type) {
                        var isActive = (
                                moment(startOfCalenderWeek).isSameOrAfter(visaTypeStartDate) &&
                                (!visaTypeEndDate || moment(startOfCalenderWeek).isSameOrBefore(visaTypeEndDate))
                            ) ||
                            (
                                moment(visaTypeStartDate).isSameOrAfter(startOfCalenderWeek) &&
                                moment(visaTypeStartDate).isSameOrBefore(endOfWeekDate)
                            )
                        self.usersWorkVisaTypes[user.id] = self.usersWorkVisaTypes[user.id] || [];
                        var workVisasTypeDetails = _.findWhere(brandWorkVisasTypes.work_visa_types, {id: template.work_visa_type.id});

                        if (workVisasTypeDetails) {
                            template.work_visa_type['require_school_template'] = workVisasTypeDetails.require_school_template;
                            template.work_visa_type['start_date'] = visaTypeStartDate;
                            template.work_visa_type['end_date'] = visaTypeEndDate;
                            template.work_visa_type['status'] = isActive ? 'ACTIVE': 'INACTIVE';
                            self.usersWorkVisaTypes[user.id].push(template.work_visa_type);
                        }
                    }
                }
            }
        };

        self.parseBrandWorkVisasRules = function (rulesList) {
            for (var i in rulesList) {
                var ruleDetails = rulesList[i];
                let activeWorkRestrictionRuleProperties = ruleDetails.work_restriction_rule_properties.map(rule => {
                    rule = { ...rule, status: "ACTIVE" };
                    if (rule.unit_type === workRestrictionsService.UNIT_TYPE.DAY) {
                        rule.unit_value_continuity = 'DISCRETE';
                    }
                    return rule; // to be same as minor rules
                });
                self.workVisasRules.push({
                    rule_properties: workRestrictionsService.prepareWorkRestrictionsRules(activeWorkRestrictionRuleProperties),
                    work_visa_type: ruleDetails.work_visa_type,
                    start_date: ruleDetails.start_date
                });
            }
        };

        self.isUserPassWorkVisaRules = (startOfWeek, userId, shifts) => {
            var weekCalenderDays = workRestrictionsService.getCalenderDays(startOfWeek);
            var weekDaysKeys = Object.keys(weekCalenderDays);
            var lastDayKey = weekDaysKeys[weekDaysKeys.length -1];
            var userInfo = TSUsersService.users[userId];
            var userWorkMap = angular.copy(workVisasUsersWorkMap[userId]) || {};
            var workVisaWarnings = {};

            if (userInfo && userInfo.hasWorkVisa()) {
                let mappedShifts = workRestrictionsService.getShiftsMap(angular.copy(shifts), true, userId);
                var shiftsPerUser = (mappedShifts[userId] && mappedShifts[userId].shifts) || [];
                var userSchoolCalender = workRestrictionsService.getUserSchoolCalender('WORK_VISA', userId);
                userWorkMap['isWeekInSession'] = workRestrictionsService.checkWeekStatus(userSchoolCalender, weekCalenderDays);

                for (var day in shiftsPerUser) {
                    var shiftsPerDay = shiftsPerUser[day];
                    for (var i = 0; i < shiftsPerDay.length; i++) {
                        var shift = shiftsPerDay[i];
                        var workVisasWarningsPerShift = {};

                        var workVisaType = self.getShiftVisaType(self.usersWorkVisaTypes[userId], shift);
                        var workVisaUserRuleSet = getWorkVisaRulesSet(self.workVisasRules, workVisaType, day);

                        if (
                            moment(shift['startTime']).isSameOrAfter(weekCalenderDays[lastDayKey].endTime) ||
                            moment(shift['startTime']).isBefore(weekCalenderDays[weekDaysKeys[0]].startTime)
                        ) {
                            continue;
                        }
                        if (
                            userSchoolCalender &&
                            userSchoolCalender[shift['shiftDay']] &&
                            userSchoolCalender[shift['shiftDay']].type !== workRestrictionsService.PERIOD_TYPES.EXEMPTION_DAY
                        ) {
                            if (workVisaUserRuleSet) {
                                userWorkMap = getWorkVisasUserWork(userWorkMap, shift);
                                workVisasWarningsPerShift = workRestrictionsService.getShiftWorkRestrictionsWarnings(userSchoolCalender, workVisaUserRuleSet, userWorkMap, shift);
                                if (workVisasWarningsPerShift.length) {
                                    return false;
                                }
                                workVisaWarnings = $.extend(workVisaWarnings, workRestrictionsService.getEmployeeWorkRestrictionsWarnings(workVisaUserRuleSet, userWorkMap, 'WORK_VISA'));
                                if (!_.isEmpty(workVisaWarnings)) {
                                    return false;
                                }
                            }
                        }
                        if (!workVisaType) {
                            var outSideVisaDatesWarning = checkOutSideVisaDatesWarnings(self.usersWorkVisaTypes[userId], shift);
                            if (outSideVisaDatesWarning) {
                                return false;
                            }
                        }
                    }
                }
            }
            return true;
        };

        const getWorkVisasUserWork = (workVisasUserWork, shift) => {
            workVisasUserWork.daysPerWeek ??= {};
            workVisasUserWork.daysPerWeek[shift.shiftDay] = (workVisasUserWork.daysPerWeek[shift.shiftDay] || 0) + (shift.costInfo?.time ?? shift.shiftTime ?? 0);

            workVisasUserWork.hoursPerWeek = (workVisasUserWork.hoursPerWeek || 0) + (shift.costInfo?.time ?? shift.shiftTime ?? 0);
            return workVisasUserWork;
        };

        self.getWorkVisaRulesViolations = function (usersShifts) {
            var violationsMap = {};

            for (var i in usersShifts) {
                var shift = usersShifts[i];

                if (shift.user_id && shift.status !== 'DELETED') {
                    var userId = shift['user_id'];
                    if (self.workVisasUsersWarning && self.workVisasUsersWarning[userId] && Object.keys(self.workVisasUsersWarning[userId]).length) {
                        for (var k in self.workVisasUsersWarning[userId]) {
                            var workVisaWarning = self.workVisasUsersWarning[userId][k];
                            var workVisaScheduleKey = workVisaWarning.key;
                            violationsMap[workVisaScheduleKey] = violationsMap[workVisaScheduleKey] || {
                                code: workVisaScheduleKey,
                                users: []
                            };
                        }
                    }

                    if (self.workVisasWarningsPerShift[shift.id] && self.workVisasWarningsPerShift[shift.id].length) {
                        for (var l in self.workVisasWarningsPerShift[shift.id]) {
                            var workVisaScheduleKey = self.workVisasWarningsPerShift[shift.id][l].key;
                            violationsMap[workVisaScheduleKey] = violationsMap[workVisaScheduleKey] || {
                                code: workVisaScheduleKey,
                                users: []
                            };
                        }
                    }
                }
            }

            return Object.keys(violationsMap);
        };

        self.prepareWorkVisasShiftsWarnings = function (startOfWeek) {
            var weekCalenderDays = workRestrictionsService.getCalenderDays(startOfWeek);
            var weekDaysKeys = Object.keys(weekCalenderDays);
            var lastDayKey = weekDaysKeys[weekDaysKeys.length -1];
            var shiftsPerUsers = workRestrictionsService.getFormattedShiftsPerUser();
            self.workVisasUsersWarning = {};
            self.workVisasWarningsPerShift = {};

            for (var userId in shiftsPerUsers) {
                var userSchoolCalender = workRestrictionsService.getUserSchoolCalender('WORK_VISA', userId);
                var userInfo = TSUsersService.users[userId];
                workVisasUsersWorkMap[userId] = {};

                if (userInfo && userInfo.hasWorkVisa()) {
                    var shiftsPerUser = shiftsPerUsers[userId].shifts;
                    workVisasUsersWorkMap[userId]['isWeekInSession'] = workRestrictionsService.checkWeekStatus(userSchoolCalender, weekCalenderDays);
                    for (var day in shiftsPerUser) {
                        var shiftsPerDay = shiftsPerUser[day];
                        for (var i = 0; i < shiftsPerDay.length; i++) {
                            var shift = shiftsPerDay[i];

                            var workVisaType = self.getShiftVisaType(self.usersWorkVisaTypes[userId], shift);
                            var workVisaUserRuleSet = getWorkVisaRulesSet(self.workVisasRules, workVisaType, day);
                            self.workVisasWarningsPerShift[shift.id] = self.workVisasWarningsPerShift[shift.id] || [];

                            if (
                                moment(shift['startTime']).isSameOrAfter(weekCalenderDays[lastDayKey].endTime) ||
                                moment(shift['startTime']).isBefore(weekCalenderDays[weekDaysKeys[0]].startTime)
                            ) {
                                continue;
                            }
                            if (
                                userSchoolCalender &&
                                userSchoolCalender[shift['shiftDay']] &&
                                userSchoolCalender[shift['shiftDay']].type !== workRestrictionsService.PERIOD_TYPES.EXEMPTION_DAY
                            ) {
                                if (workVisaUserRuleSet) {
                                    workVisasUsersWorkMap[userId] = getWorkVisasUserWork(workVisasUsersWorkMap[userId], shift);
                                    self.workVisasWarningsPerShift[shift.id] = workRestrictionsService.getShiftWorkRestrictionsWarnings(userSchoolCalender, workVisaUserRuleSet, workVisasUsersWorkMap[userId], shift);
                                    self.workVisasUsersWarning[userId] = self.workVisasUsersWarning[userId] || {};
                                    self.workVisasUsersWarning[userId] = $.extend(self.workVisasUsersWarning[userId], workRestrictionsService.getEmployeeWorkRestrictionsWarnings(workVisaUserRuleSet, workVisasUsersWorkMap[userId], 'WORK_VISA'));
                                }
                            }
                            var isExemptionDay = userSchoolCalender && userSchoolCalender[shift.day] && userSchoolCalender[shift.day].type == workRestrictionsService.PERIOD_TYPES.EXEMPTION_DAY;
                            if (isExemptionDay) {
                                continue;
                            }

                            if (workVisaType) {
                                if (
                                    workVisaType &&
                                    workVisaType.require_school_template &&
                                    workVisaUserRuleSet &&
                                    (!userSchoolCalender || !userSchoolCalender[shift.day])
                                ) {
                                    self.workVisasWarningsPerShift[shift.id].push({
                                        key: 'WORK_VISA'+ '_EMPLOYEE_NO_EFFECTIVE_SCHOOL_CALENDAR',
                                        restrictionType: 'WORK_VISA'
                                    });
                                }
                            }
                            else {
                                var outSideVisaDatesWarning = checkOutSideVisaDatesWarnings(self.usersWorkVisaTypes[userId], shift);
                                if (outSideVisaDatesWarning) {
                                    self.workVisasUsersWarning[userId] = self.workVisasUsersWarning[userId] || {};
                                    self.workVisasUsersWarning[userId][outSideVisaDatesWarning.key] = outSideVisaDatesWarning;
                                }
                            }
                        }
                    }
                }
                else {
                    if (!userInfo) {
                        console.warn('user has no details' + userId)
                    }
                }
            }
        };

        var checkOutSideVisaDatesWarnings = function (userWorkVisaTypes, shift) {
            if (userWorkVisaTypes && userWorkVisaTypes.length) {
                for (var i = 0; i < userWorkVisaTypes.length; i++) {
                    var userWorkVisaType = userWorkVisaTypes[i];

                    if (userWorkVisaType.end_date && moment(shift.startTime).isAfter(userWorkVisaType.end_date)) {
                        var endDateFormatted = moment(userWorkVisaType.end_date).format('MMM DD, YYYY');
                        return  {
                            key: 'AFTER_VISA_END_DATE',
                            date: endDateFormatted
                        }
                    }

                    if (moment(shift.startTime).isBefore(userWorkVisaType.start_date)) {
                        var startDateFormatted = moment(userWorkVisaType.start_date).format('MMM DD, YYYY');
                        return  {
                            key: 'BEFORE_VISA_START_DATE',
                            date: startDateFormatted
                        }
                    }
                }
            }
            return null;
        };

        var getWorkVisaRulesSet = function (workRules, userVisaType, shiftDay) {
            var matchedWorkVisaRules = workRules.filter(function (rule) {
                return (
                    rule.work_visa_type &&
                    userVisaType &&
                    rule.work_visa_type.id === userVisaType.id &&
                    moment(shiftDay).isSameOrAfter(rule.start_date)
                );
            });

            if (matchedWorkVisaRules.length) {
                var latestRule = matchedWorkVisaRules[matchedWorkVisaRules.length-1];
                return latestRule && latestRule['rule_properties'];
            }
          return null;
        };

        self.getShiftVisaType = function (userWorkVisaTypes, shift) {
            if (userWorkVisaTypes && userWorkVisaTypes.length) {
                for (var i = 0; i < userWorkVisaTypes.length; i++) {
                    var userWorkVisaType = userWorkVisaTypes[i];

                    if (
                        moment(shift.startTime).isSameOrAfter(userWorkVisaType.start_date) &&
                        userWorkVisaType.status == 'ACTIVE' &&
                        (!userWorkVisaType.end_date || moment(shift.startTime).isSameOrBefore(userWorkVisaType.end_date))
                    ) {
                        return userWorkVisaType;
                    }
                }
            }
            return null;
        };

        self.reset = function () {
            self.workVisasRules = [];
            self.usersWorkVisaTypes = {};
            self.workVisasWarningsPerShift = {};
            self.workVisasUsersWarning = {};
            workVisasUsersWorkMap = {};
        };
    }

    app.service('workVisasService', WorkVisasService);

}());